<template>
  <v-main class="pa-5 pt-0 height-10">
    <v-container fluid class="height-10">
      <v-row> </v-row>
      <v-row class="mt-2">
        <h1 v-if="$route.query.title">{{ $route.query.title }}</h1>
        <h1 v-else-if="!$route.query.questionNo">
          {{ $t($route.meta.title) }}
        </h1>
        <h1 v-else>{{ $route.query.questionNo }}</h1>
      </v-row>
      <div>
        <slot />
      </div>
    </v-container>
  </v-main>
</template>

<script>
export default {
  name: "MainView",
  created() {
    console.log("this.$route", this.$route);
  },
};
</script>
